import MonthlyCuts from '@/components/monthly_cuts/MonthlyCuts'
import MonthlyCutCreate from '@/components/monthly_cuts/MonthlyCutCreate'
import MonthlyCutUpdate from '@/components/monthly_cuts/MonthlyCutUpdate'
import MonthlyCutDetail from '@/components/monthly_cuts/MonthlyCutDetail'

const monthlyCutsRoutes = [
  { path: '/monthly_cuts', name: 'monthly_cuts', component: MonthlyCuts },
  { path: '/monthly_cut/create', name: 'monthly_cut_create', component: MonthlyCutCreate },
  { path: '/monthly_cut/:id/update', name: 'monthly_cut_update', component: MonthlyCutUpdate },
  { path: '/monthly_cut/:id', name: 'monthly_cut', component: MonthlyCutDetail }
]

export default monthlyCutsRoutes



// WEBPACK FOOTER //
// ./src/router/monthly_cuts_routes.js